/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIconMarker/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIconMarker({
  children,
  viewPath = "/DesignSystem/ButtonIconMarker",
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  marginBottom = 0,
  onClick,
  goTo,
  isDisabled,
  paddingTop,
  paddingLeft,
  paddingBottom,
  paddingRight,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let paddingTopOrdtSpaceXs = paddingTop ?? dtSpaceXs
let paddingLeftOrdtSpaceXs = paddingLeft ?? dtSpaceXs
let paddingBottomOrdtSpaceXs = paddingBottom ?? dtSpaceXs
let paddingRightOrdtSpaceXs = paddingRight ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="ButtonIconMarker.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="ButtonIconMarker.Vertical:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={isDisabled}
 style={{'--bblr-2-1k8rbG': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-1k8rbG': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-1k8rbG': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-1k8rbG': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-6-1k8rbG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-7-1k8rbG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-8-1k8rbG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-9-1k8rbG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pt-10-1k8rbG': typeof paddingTopOrdtSpaceXs === 'number' ? `${paddingTopOrdtSpaceXs}px` : paddingTopOrdtSpaceXs,'--pl-11-1k8rbG': typeof paddingLeftOrdtSpaceXs === 'number' ? `${paddingLeftOrdtSpaceXs}px` : paddingLeftOrdtSpaceXs,'--pb-12-1k8rbG': typeof paddingBottomOrdtSpaceXs === 'number' ? `${paddingBottomOrdtSpaceXs}px` : paddingBottomOrdtSpaceXs,'--pr-13-1k8rbG': typeof paddingRightOrdtSpaceXs === 'number' ? `${paddingRightOrdtSpaceXs}px` : paddingRightOrdtSpaceXs,'--bc-1-1k8rbG': isSelected ? dtColorsNeutral300 : "transparent"}}
 className={`views-block ${styles.Vertical1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</a>
</div>
</React.Fragment>)
}